import { rgb } from "d3-color";
import { SeriesColumnOptions } from "highcharts";
import { SCKpis } from "../../common/generic/generic-sc-domain";
import { IGenericAggregateResponse } from "../../common/generic/generic-types";
import { IRevenueCategoryData } from "./types";

export const Helper = {
  BuildChartOptions,
  MapData,
};

export function MapData(response: IGenericAggregateResponse) {
  const ranges = [
    {
      alpha: 0.2,
      label: "<100 K€",
      max: 100000,
      min: Number.NEGATIVE_INFINITY,
    },
    { alpha: 0.4, label: "100 K€-500 K€", max: 500000, min: 100000 },
    { alpha: 0.6, label: "500 K€-1 Mln€", max: 1000000, min: 500000 },
    { alpha: 0.8, label: "1 Mln€-3 Mln€", max: 3000000, min: 1000000 },
    {
      alpha: 1,
      label: ">3 Mln€",
      max: Number.POSITIVE_INFINITY,
      min: 3000000,
    },
  ];

  const mappedData = {
    entries: [],
    totalSc: response.aggregates
      ? response.aggregates
          .map(row => row.indicatorKpiValues[SCKpis.SC_YTD])
          .reduce((sum, scYtd) => sum + scYtd, 0)
      : 0,
  } as IRevenueCategoryData;

  ranges.forEach(range => {
    let nbClients = 0;
    let scAmount = 0;
    if (response.aggregates) {
      const rows = response.aggregates.filter(
        row =>
          row.indicatorKpiValues[SCKpis.SC_YTD] >= range.min &&
          row.indicatorKpiValues[SCKpis.SC_YTD] < range.max
      );
      nbClients = rows.length;
      scAmount = rows
        .map(row => row.indicatorKpiValues[SCKpis.SC_YTD])
        .reduce((sum, scYtd) => sum + scYtd, 0);
    }

    mappedData.entries.push({
      alpha: range.alpha,
      label: range.label,
      nbClients,
      scAmount,
    });
  });

  return mappedData;
}

export function BuildChartOptions(
  mappedData: IRevenueCategoryData
): Highcharts.Options {
  return {
    plotOptions: {
      series: {
        dataLabels: {
          align: "center",
          enabled: true,
          format: "{point.nb:,.0f}",
          inside: false,
        },
      },
    },
    series: buildSeries(mappedData),
    tooltip: {
      pointFormat:
        "Number of clients: <b>{point.nb}</b><br />% SC YTD: <b>{point.y:,.2f}%</b>",
      shared: true,
    },
    xAxis: {
      categories: mappedData.entries.map(entry => entry.label),
      crosshair: true,
    },
    yAxis: {
      ceiling: 100,
      floor: 0,
      labels: {
        format: "{value}%",
      },
      tickInterval: 5,
      title: {
        text: "% SC YTD",
      },
    },
  };
}

function buildSeries(mappedData: IRevenueCategoryData): SeriesColumnOptions[] {
  return [
    {
      data: mappedData.entries.map(entry => {
        return {
          color: rgb(220, 73, 65, entry.alpha).toString(),
          nb: entry.nbClients,
          y:
            mappedData.totalSc > 0
              ? (entry.scAmount / mappedData.totalSc) * 100
              : 0,
        };
      }),
      showInLegend: false,
      type: "column",
    },
  ];
}
